import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {createTask, getTask, completeTask, getEmployees} from "../../redux/actions/taskActions";
import moment from 'moment';

import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";


import { MinusCircle, PlusCircle } from "react-feather";


import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  Table
} from "reactstrap";



const Tasks = ({auth, tasks, createTask, getTask, completeTask, getEmployees}) => {
  useEffect(() => {
      getTask();
      getEmployees();
    }, [getTask, getEmployees]);

  const [newTask, setNewTask] = useState({
    area: '',
    assignedTo: '',
    jobDescription: ''
  })
  const updateNewTask = e => setNewTask({...newTask, [e.target.name]: e.target.value});
  const submitTask = () => {
    newTask.assignedBy = {value: auth.user._id, name: auth.user.name}
    console.log(newTask)
    createTask(newTask);
    setNewTask({
      area: '',
      assignedTo: '',
      jobDescription: '',
    })
  }
  const setFile = e => setNewTask({...newTask, file: e.target.files[0]})

  const dateFormatter = (cell, row) => {
    if(row.dateCompleted) {
      return(
        <span>{moment.utc(cell).format('MM-DD-YYYY')}</span>
      )
    }
  }



  const tableColumns = [
    {
      dataField:"dateCompleted",
      text: "Date Completed",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "assignedTo.name",
      text: "Assigned To",
      sort: true,
    },
    {
      dataField: "assignedBy.name",
      text: "Assigned By",
      sort: true,
    },
    {
      dataField: "area",
      text: "Area",
      sort: true,
    },
  ]

  const ExpandableRowsTable = () => {
    const expandRow = {
      renderer: row => (
          <Card>
            <CardBody>
              <Table size="sm" className="my-2">
                <tbody>
                  <tr>
                    <th>Area</th>
                    <td>{row.area}</td>
                  </tr>
                  <tr>
                    <th>Assigned By</th>
                    <td>{row.assignedBy.name}</td>
                  </tr>
                  <tr>
                    <th>Assigned To</th>
                    <td>{row.assignedTo.name}</td>
                  </tr>
                  <tr>
                    <th>Date Created</th>
                    <td>{moment.utc(row.dateCreated).format('MM-DD-YYYY')}</td>
                  </tr>
                  <tr>
                    <th>Date Completed</th>
                    <td>{moment.utc(row.dateCompleted).format('MM-DD-YYYY')}</td>
                  </tr>
                  <tr>
                    <th>Task</th>
                    <td>{row.jobDescription}</td>
                  </tr>
                  {(row.filename) &&
                    <tr>
                      <th>Image</th>
                      <td>
                        <img src={`/api/jobs/image/${row.filename}`} className="img-fluid pr-1" alt="Unsplash" />
                      </td>
                    </tr>
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
      ),
      showExpandColumn: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) =>
        isAnyExpands ? (
          <MinusCircle width={16} height={16} />
        ) : (
          <PlusCircle width={16} height={16} />
        ),
      expandColumnRenderer: ({ expanded }) =>
        expanded ? (
          <MinusCircle width={16} height={16} />
        ) : (
          <PlusCircle width={16} height={16} />
        )
    };

    return (
      <Card>
        <CardHeader>
          <CardTitle tag="h5">Completed Tasks</CardTitle>
          <h6 className="card-subtitle text-muted">
            Click to expand
          </h6>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            bootstrap4
            bordered={false}
            keyField="name"
            data={tasks.completedTasks}
            columns={tableColumns}
            expandRow={expandRow}
            pagination={paginationFactory({
              sizePerPage: 5,
              sizePerPageList: [5, 10, 25, 50]
            })}
          />
        </CardBody>
      </Card>
    );
  };


  return (
    <Container fluid className="p-0">
      <h1 className="h3 mb-3"><Button>Create New Task</Button></h1>
      <Row>
        <Col lg="6" xl="4">
        <Card>
        <CardHeader>
          <CardTitle tag="h5">New Task</CardTitle>
          <h6 className="card-subtitle text-muted">Create New Task</h6>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Area
              </Label>
              <Col sm={9}>
                <Input name="area" value={newTask.area} placeholder="Ex: A7" onChange={(e) => updateNewTask(e)} required/>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Assign to
              </Label>
              <Col sm={9}>
                <Select
                  name="assignedTo"
                  options={tasks.employees}
                  onChange={(e) => setNewTask({...newTask, assignedTo: {value: e.value, name: e.label}})}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={3} className="text-sm-left">
                Task Description
              </Label>
              <Col sm={9}>
                <Input
                  type="textarea"
                  name="jobDescription"
                  placeholder="Task Description"
                  rows="3"
                  value={newTask.jobDescription}
                  onChange={(e) => updateNewTask(e)}
                  required
                />
              </Col>
            </FormGroup>
            <FormGroup row>
                <Label sm={3} className="text-sm-left">
                </Label>
                <Col sm={9}>
                  <Input
                    type="file"
                    name="note"
                    onChange={(e) => setFile(e)}
                    required
                  />
                </Col>
              </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 10, offset: 2 }}>
                <Button color="primary" onClick={() => submitTask()}>Submit Task</Button>
              </Col>
            </FormGroup>
          </Form>
        </CardBody>
        </Card>

        </Col>
        <Col lg="6" xl="8">
          <Card>
            <CardHeader>
              <CardTitle tag="h5">To Do</CardTitle>
            </CardHeader>
            <CardBody className="p-3">
              {(tasks.openTasks) && tasks.openTasks.map((task, index) =>
                <Card key={index}>
                  <CardHeader>
                    <CardTitle className='h5'>{task.assignedTo.name} <small className="float-right">{moment.utc(task.dateCreated).fromNow()}</small></CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Table size="sm" className="my-2">
                      <tbody>
                        <tr>
                          <th>Area</th>
                          <td>{task.area}</td>
                        </tr>
                        <tr>
                          <th>Assigned By</th>
                          <td>{task.assignedBy.name}</td>
                        </tr>
                        <tr>
                          <th>Task</th>
                          <td>{task.jobDescription}</td>
                        </tr>
                        {(task.filename) &&
                          <tr>
                            <th>Image</th>
                            <td>
                              <img src={`/api/jobs/image/${task.filename}`} className="img-fluid pr-1" alt="Unsplash" />
                            </td>
                          </tr>
                        }
                      </tbody>
                    </Table>
                    <Button color="success" onClick={() => completeTask(task) } block>Complete</Button>
                  </CardBody>
                </Card>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
        <Row>
        <Col lg="6" xl="12">
           <ExpandableRowsTable/>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = state => ({
  tasks: state.tasks,
  auth: state.auth
})

export default connect(mapStateToProps, {createTask, getTask, completeTask, getEmployees})(Tasks);
